import roomMoves from "./roomMoves";
import deviceStatus from "./deviceStatus";
import fixWizard from "./fixWizard";

export default {
	namespaced: true,
	modules: {
		roomMoves,
		deviceStatus,
		fixWizard,
	},
};
